import {Grid} from 'jrgrid';
import { columns } from './utils';
import { PAGE_SETTINGS } from './api';
import Navbar from '../../../components/Navbar';
import React, { Component, Fragment } from 'react';

class Settings extends Component {
  render() {
    return (
      <Fragment>
        <Navbar />
        <h2 className="ml-5 mt-2">Settings</h2>
        <h4 className="ml-5 mt-2">The following settings will require you to log out and log back in to see the change:</h4>
        <div className="ml-5 mr-5">
          <Grid
            amount={5}
            columns={columns}
            defaultSortField="settingId"
            query={PAGE_SETTINGS}
            queryName="pageSettings"
            globalFilters={[
              {
                id: 'refreshMethod',
                isLike: false,
                operand: 'and',
                type: 'string',
                value: 'Login',
              },
            ]}
          />
        </div>

        <h4 className="ml-5 mt-2">
          If you need to make a change to one of these settings, please contact OIT. The following settings will require
          Asset Inventory's server to be restarted:
        </h4>
        <div className="ml-5 mr-5">
          <Grid
            amount={5}
            columns={columns}
            defaultSortField="settingId"
            query={PAGE_SETTINGS}
            queryName="pageSettings"
            globalFilters={[
              {
                id: 'refreshMethod',
                isLike: false,
                operand: 'and',
                type: 'string',
                value: 'Server Restart',
              },
            ]}
          ></Grid>
        </div>
      </Fragment>
    );
  }
}

export default Settings;
